<template>
  <div class="columns is-gapless full-width">
    <div class="column is-narrow list-border is-hidden-touch">
      <Mylist v-if="is_login && is_my_list" class="force-show-list" :is_show_edit_button="false"/>
      <Followlist v-if="is_login && !is_my_list" class="force-show-list" :is_show_edit_button="false"/>
    </div>
    <div class="column list-content">
      <div style="margin: 0.5em">
        <div>
          <b-message 
            title="お知らせ" 
            type="is-info" 
            aria-close-label="Close message">
            TwitterのAPI仕様変更により、ツイート情報を直接取得することができなくなりました。
            そのため、一時的にツイートの埋め込み機能を使ってストックしたツイートを表示しています。
            今後再度の仕様変更でツイートが表示できなくなる可能性もあるので、表示できているうちに結果をダウンロードしておくことをおすすめします。
          </b-message>
          <div style="text-align: right;">
            <b-icon icon="share-alt" style="margin-left:1em;"
                    @click.native="twitterShare()">
            </b-icon>
            <b-icon icon="edit" style="margin-left:1em;" v-if="is_login && is_my_list"
                    v-bind:type="{'is-danger': is_edit}" @click.native="is_edit = !is_edit">
            </b-icon>
            <b-icon icon="plus-square" style="margin-left:1em;" v-if="is_login && !is_my_list"
                    @click.native="follow_stock">
            </b-icon>
            <!-- <b-icon icon="search" style="margin-left:0.8em;"></b-icon> -->
          </div>
          <div class="list-header">
            <p class="is-size-4 has-text-grey-dark">
              {{ list_title }}
              <span class="is-size-6 has-text-grey">
                @{{user_id}}
              </span>
            </p>
            <b-field class="search-padding" v-if="is_edit">
              <b-input placeholder="ツイートのurl" type="url" v-model="add_tweet_url" expanded></b-input>
              <p class="control">
                <span class="button is-success" @click="add_tweet_by_url">追加</span>
              </p>
            </b-field>
            <b-notification
              auto-close type="is-danger"
              :active.sync="is_alert_active"
              aria-close-label="Close notification">
              ツイートのurlではありません。再入力してください。
            </b-notification>
            <b-pagination
                :total="list_tweets.length"
                :current.sync="current_page_num"
                :range-before="2"
                :range-after="1"
                :order="'is-centered'"
                :size="''"
                :rounded="true"
                :per-page="one_page_tweet_num"
                :icon-prev="'chevron-left'"
                :icon-next="'chevron-right'"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                type="is-danger">
            </b-pagination>
          </div>
        </div>
        <div  class="columns is-gapless is-multiline is-desktop">
          <div v-for="tweet in tweet_contents" :key="tweet.id" class="column is-4-desktop">
            <div class="tweet-box" >
              <CustomEmbededTweet :tweet_id="tweet.id"/>
              <b-button type="is-danger" v-if="is_edit" @click="remove_tweet(tweet.id)" expanded>ストックから外す</b-button>
              <b-button type="is-primary" v-if="is_edit" @click="open_mylistmodal(tweet.id)" expanded>別のストックに移動する</b-button>
            </div>
          </div>
        </div>
        <MylistModal :tweet_id="modal_tweet" v-model="is_modal_open" @add-tweet="remove_tweet(modal_tweet)"/>
        <div style="padding: 0.5em;" class="list-header">
          <b-pagination
              :total="list_tweets.length"
              :current.sync="current_page_num"
              :range-before="2"
              :range-after="1"
              :order="'is-centered'"
              :size="''"
              :rounded="true"
              :per-page="one_page_tweet_num"
              :icon-prev="'chevron-left'"
              :icon-next="'chevron-right'"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
              type="is-danger">
          </b-pagination>
        </div>
        <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
      </div>
    </div>
  </div>
</template>

<script>
import {get_list_info} from '@/util/mylist_util.js'
import CustomEmbededTweet from '@/components/CustomEmbededTweet.vue'
import Mylist from '@/views/Mylist.vue'
import Followlist from '@/views/Followlist.vue'
import MylistModal from '@/components/MylistModal.vue'

export default {
  title() {
    return "- " + this.list_title
  },
  components: {
    CustomEmbededTweet,
    Mylist,
    Followlist,
    MylistModal,
  },
  data() {
    return {
      list_tweets: [],
      tweet_contents: [],
      list_title: "",
      user_id: "",
      add_tweet_url: "",
      is_alert_active: false,
      is_edit: false,
      current_page_num: 1,
      isLoading: false,
      is_modal_open: false,
      modal_tweet: "",
    }
  },
  computed: {
    tweet_num() {
      return this.list_tweets.length
    },
    list_id() {
      return this.$route.params.id
    },
    page_num() {
      if(this.$route.query.page == undefined){return 1}
      return this.$route.query.page
    },
    one_page_tweet_num: () => 15,
    is_my_list() {
      if(this.$store.getters.isJudgeMyListAndReturnListName(this.list_id) == ""){return false}
      return true
    },
    is_login() {
      return this.$store.getters.isLogin
    }
  },
  watch:{
    current_page_num(val) {
      this.move_list_page(val)
    },
    list_id: {
      handler: "show_list",
      immediate: true,      
    },
  },
  methods: {
    async show_list() {
      console.log("show_liqst")
      this.isLoading = true
      if(this.is_my_list){
        const list_name = this.$store.getters.isJudgeMyListAndReturnListName(this.list_id)
        const list_tweets = this.$store.getters.getListTweets(list_name)
        this.list_tweets = JSON.parse(JSON.stringify(list_tweets)).reverse()
        this.list_title = list_name
        this.user_id = this.$store.getters['getUserInfo'].twitter_id
      }
      else{
        const list_info = await get_list_info(this.list_id)
        this.list_tweets = list_info.tweets.reverse()
        this.list_title = list_info.list_name
        this.user_id = list_info.create_user_id
      }
      this.isLoading = false
      await this.getTweetInfoList()
    },
    async getTweetInfoList() {
      console.log("getTweetInfoList")
      const start_idx = this.one_page_tweet_num*(this.page_num-1)
      const end_idx = start_idx + this.one_page_tweet_num
      const tgt_list_tweets = this.list_tweets.filter((elm, idx) => start_idx<=idx && idx<end_idx)
      console.log(tgt_list_tweets)
      this.tweet_contents = []
      for(let idx in tgt_list_tweets){
        console.log(tgt_list_tweets[idx])
        // const tweetInfo = await this.$store.dispatch('getTweetInfoByID', tgt_list_tweets[idx])
        // if(Object.keys(tweetInfo).length == 0) continue  // 空のオブジェクトは飛ばす
        const tweetInfo = {
          id: tgt_list_tweets[idx],
        }
        this.tweet_contents.push(tweetInfo)
      }
    },
    async add_tweet_by_url() {
      let add_tweet_id = this.add_tweet_url
      const url_split = this.add_tweet_url.split("/")
      if(url_split.length > 0){
        add_tweet_id = url_split[url_split.length-1]
      }
      const is_valid_tweet_id = Number.isInteger(Number(add_tweet_id))
      if(is_valid_tweet_id == false){
        this.is_alert_active = true
        return
      }
      if(this.list_tweets.indexOf(add_tweet_id) == -1){
        this.$store.commit("addTweetToList", {list_id:this.list_id, tweet_id:add_tweet_id})
        this.list_tweets.unshift(add_tweet_id)
        this.getTweetInfoList()
      }
      this.add_tweet_url = ""
    },
    remove_tweet(remove_tweet_id) {
      this.$store.commit("removeTweetFromList", {list_id:this.list_id, remove_tweet_id:remove_tweet_id})
      this.list_tweets = this.list_tweets.filter(id => id !== remove_tweet_id)
      this.tweet_contents = this.tweet_contents.filter(t => t.id !== remove_tweet_id)
      this.list_tweets.splice()
    },
    move_list_page(move_page) {
      if(this.list_tweets.length <= this.one_page_tweet_num*(move_page-1)) return
      window.scrollTo({top: 100})
      this.$router.push({path:`/stock/${this.$route.params.id}`, query: { page: move_page } }).catch(()=>{})
      this.getTweetInfoList()
    },
    twitterShare(){
      const twitter_share_url = 'https://twitter.com/intent/tweet'
      const tweet_content = `${this.list_title} @${this.user_id} のストック`
      const current_url_without_query = location.href.split(/[?#]/)[0]
      const hashtag = "Twistock"
      const shareURL = `${twitter_share_url}?text=${tweet_content}&url=${current_url_without_query}&hashtags=${hashtag}`  
      location.href = shareURL
    },
    async follow_stock() {
      const add_list_id = this.$route.params.id
      const is_sucess = await this.$store.dispatch("addFollowlist", add_list_id)
      if(is_sucess == true){
        this.$buefy.toast.open('ストックを追加しました！')
      }
      else{
        this.$buefy.toast.open('すでにフォロー済みです')
      }
    },
    async open_mylistmodal(move_tweet_id) {
      this.modal_tweet = move_tweet_id
      this.is_modal_open = true
    }
  },
}
</script>

<style>
.search-padding {
  margin-right: 0.5em;
  margin-left: 0.5em;
}

.tweet-box {
  max-width: 400px;
	margin-left: auto;
	margin-right: auto;
  margin-top: 1em;
  margin-bottom: 1em;
  border: solid;
  border-width: 1px;
  border-color: #eee;
}

.list-header {
  max-width: 40em;
  margin: 0 auto;
}

.force-show-list {
  margin-top:0px !important;
  width: 240px !important;
}

.list-border {
  border-right: 1px solid #cccccc;
}

.full-width {
  max-width: none !important;
}

.list-content {
  max-width: 1300px;
	margin-left: auto !important;
	margin-right: auto !important;
}
</style>